// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"RecoveryPassword_loadingWrapper__EBK1f"};